import React, {useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Row, Col, Dropdown, Container} from 'react-bootstrap';
import SearchBar from './SearchBar.js';
import { useLanguage } from "../LanguageContext";
import logo from '../assets/images/iqosys_logo.png';
import '../assets/styles/Header.css';

/* Header.js is a functional component that renders the top of the page with the logo,
slogan and first navigation bar. setActiveNav is used to determine wich page has been clicked
in the first NavBar to then display the second NavBar from App.js */

const Header = () => {
  const { language, translations, toggleLanguage } = useLanguage();
  const text = translations[language].header;

  const [top_sentence, setTopSentence] = useState('doing what humans do best');
  const location = useLocation(); // Hook to catch the current URL

  // useEffect is used to change the top sentence depending on the URL
  useEffect(() => {
    switch (location.pathname) {
      case '/myaccount/signin':
        setTopSentence('elite talent for your digital projects');
        break;
      case '/myaccount/register':
        setTopSentence('unlock the power of decentralized networks');
        break;
      case '/aboutus/services':
        setTopSentence('aligned objectives ensure replicable success');
        break;
      case '/aboutus/practices':
        setTopSentence('single point of access to all your expert needs');
        break;
      case '/aboutus/clients':
        setTopSentence('fully committed to your business results');
        break;
      case '/aboutus/execpartners':
        setTopSentence('realize your full potential');
        break;
      case '/aboutus/consultants':
        setTopSentence('strategic projects with top tier clients');
        break;
      case '/aboutus/iqosystem':
        setTopSentence('network value = [network users]²');
        break;
      case '/aboutus/iqstokens':
        setTopSentence('become a valued IQOSYS shareholder');
        break;
      case '/ourleaders/sector':
        setTopSentence('passionate, capable, inspiring');
        break;
      case '/ourleaders/function':
        setTopSentence('');
        break;
      case '/ourleaders/practice':
        setTopSentence('');
        break;
      case '/projects':
        setTopSentence('apply for a role and join the IQOSYS partnership');
        break;
      case '/publications':
        setTopSentence('thought leadership to accelerate innovation');
        break;
      case '/contact':
        setTopSentence('where people meet people … come join us');
        break;
      default:
        setTopSentence('doing what humans do best');
        break;
    }
  }, [location.pathname]);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/') ;
  };

  return (
    <div>
      <div className="header-container">
        <Row className="w-100">
        <Col md={3} className="d-flex flex-column align-items-center">
          <Navbar.Brand as={Link} to="/">
            <img src={logo} alt="logo" className='w-100 pb-1 pt-2' style={{paddingLeft: '6%'}}/>
          </Navbar.Brand>
        </Col>
        <Col md={9} className="d-flex flex-row align-items-center">
        <span className="top-sentence" style={{paddingLeft:"10px"}}>{top_sentence}</span>
        </Col>
        </Row>
      </div>

      {/* The first NavBar is rendered with the SearchBar component and the links to the different pages */}
      <Container fluid className="d-flex justify-content-center" style={{paddingRight:"0"}}>
        <Row className="w-100">
          <Col md={3} className="d-flex flex-column align-items-start m-0">
            <SearchBar/>
          </Col>
          <Col md={7} className="d-flex flex-column align-items-start p-0">
            <Navbar expand="sm" className="custom-navbar w-100 p-0" style={{backgroundColor:"#f2f2f2",marginBottom:"5px"}}>
                {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav variant="pills" className="ml-auto w-100 d-flex justify-content-center principal-nav" key={location.pathname}>
                    <Nav.Link className={isActive('/myaccount') ? 'active-link' : 'unactive-link'} as={Link} to="/myaccount/signin">{text.myAccount}</Nav.Link>
                    <Nav.Link className={isActive('/aboutus') ? 'active-link' : 'unactive-link'} as={Link} to="/aboutus/services">{text.aboutUs}</Nav.Link>
                    <Nav.Link className={isActive("/ourleaders") ? 'active-link' : 'unactive-link'} as={Link} to="/ourleaders/sector">{text.ourLeaders}</Nav.Link>
                    <Nav.Link className={isActive("/projects") ? 'active-link' : 'unactive-link'} as={Link} to="/projects">{text.projects}</Nav.Link>
                    <Nav.Link className={isActive("/publications") ? 'active-link' : 'unactive-link'} as={Link} to="/publications">Publications</Nav.Link>
                    <Nav.Link className={isActive("/contact") ? 'active-link' : 'unactive-link'} as={Link} to="/contact">{text.contactUs}</Nav.Link>
                  </Nav>
                </Navbar.Collapse>
            </Navbar>
          </Col>
          <Col md={2} className="language d-flex flex-column justify-content-center align-items-start p-0" style={{borderLeft: "#d9d9d9 1px solid !important", backgroundColor:"#f2f2f2",marginBottom:"5px", paddingRight : '0'}}>
            <Dropdown>
              <Dropdown.Toggle variant="light" id="dropdown-language" style={{color : "#0000ff", backgroundColor: "transparent", border : "none"}}>
                {text.language}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{padding : "0", margin : "0"}}>
                <Dropdown.Item onClick={() => toggleLanguage("en")}>English</Dropdown.Item>
                <Dropdown.Item onClick={() => toggleLanguage("fr")}>Français</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Header;